import { useTranslation } from 'react-i18next';
import { Bubble } from '@tencent/tea-component';

import './MeetingEncrypted.css';

const MeetingEncrypted = () => {
  const { t } = useTranslation();

  return (
    <Bubble
      content={t('会议已加密保护')}
      placement="bottom-end"
      overlayStyle={{
        left: '15px',
      }}
      overlayClassName="meeting-encrypted__bubble"
    >
      <div className="meeting-encrypted__icon" />
    </Bubble>
  );
};

export default MeetingEncrypted;
